import { useRef } from 'react';

import { useCompanyId } from 'application/providers/AccountProvider';

import useAcceptanceAdvancedStartSigning from 'domain/billing/useAcceptanceAdvancedStartSigning';

interface AcceptanceAdvancedModalViewModel {
  startSigningAcceptanceAdvancedLoading: boolean;
  handleRedirectToAcceptanceAdvanced: () => Promise<void>;
}

interface Props {
  uriForReturn: string;
  showStartSigningErrorNotification: () => void;
  close: (count?: number) => void;
}

const useAcceptanceAdvancedModalViewModel = ({
  uriForReturn,
  showStartSigningErrorNotification,
  close,
}: Props): AcceptanceAdvancedModalViewModel => {
  const sbbolTabOpenedRef = useRef<Window | null>(null);

  const companyId = useCompanyId();

  const { request, loading: startSigningAcceptanceAdvancedLoading } = useAcceptanceAdvancedStartSigning();

  const handleRedirectToAcceptanceAdvanced = async () => {
    const link = await request({ companyId, uriForReturn: `${window.location.origin}${uriForReturn}` });

    if (link) {
      if (sbbolTabOpenedRef.current !== null && !sbbolTabOpenedRef.current.closed) {
        sbbolTabOpenedRef.current.focus();

        return;
      }

      sbbolTabOpenedRef.current = window.open(link, '_blank');

      if (sbbolTabOpenedRef.current) {
        sbbolTabOpenedRef.current.opener = window;
      }

      close(2);
    } else {
      showStartSigningErrorNotification();
    }
  };

  return {
    handleRedirectToAcceptanceAdvanced,
    startSigningAcceptanceAdvancedLoading,
  };
};

export default useAcceptanceAdvancedModalViewModel;
